export default __webpack_public_path__ + "static/DSC_0093-679779fb33d9282cfe146947034ed1c3.jpg";